import {
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  GET_USER_DETAIL,
  ADD_NEW_USER,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  GET_USER_DETAIL_FAIL,
  GET_USER_DETAIL_SUCCESS,
  CLEAR_MESSAGE,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  RESET_DATA,
  UPDATE_SEASON_CHANGE_STATUS,
  UPDATE_SEASON_CHANGE_STATUS_SUCCESS,
  UPDATE_SEASON_CHANGE_STATUS_FAIL,
  BLACKLIST_USER,
  BLACKLIST_USER_SUCCESS,
  BLACKLIST_USER_FAIL,
  GET_UNAPPROVE_COUNT,
  GET_UNAPPROVE_COUNT_SUCCESS,
  GET_UNAPPROVE_COUNT_FAIL,
  GET_EXPORT_USERS,
  GET_EXPORT_USERS_SUCCESS,
  GET_EXPORTED_USERS_FAIL,
  RESET_EXPORT_DATA,
  CLEAR_STRIPE_ERROR,
  CHARGE_USER,
  CHARGE_USER_SUCCESS,
  CHARGE_USER_FAIL,
  GET_BILL_PRICE,
  GET_BILL_PRICE_SUCCESS,
  GET_BILL_PRICE_FAIL,
  GET_CHANGESEASON_USERS,
  GET_CHANGESEASON_USERS_FAIL,
  GET_CHANGESEASON_USERS_SUCCESS,
} from "./actionTypes"

export const getUsers = payload => ({
  type: GET_USERS,
  payload: { ...payload },
})

export const getUsersSuccess = Users => ({
  type: GET_USERS_SUCCESS,
  payload: Users,
})

export const addNewUser = User => ({
  type: ADD_NEW_USER,
  payload: User,
})

export const addUserSuccess = User => ({
  type: ADD_USER_SUCCESS,
  payload: User,
})

export const addUserFail = error => ({
  type: ADD_USER_FAIL,
  payload: error,
})

export const updateUser = User => ({
  type: UPDATE_USER,
  payload: User,
})

export const updateUserSuccess = User => ({
  type: UPDATE_USER_SUCCESS,
  payload: User,
})

export const updateUserFail = error => ({
  type: UPDATE_USER_FAIL,
  payload: error,
})

export const getUsersFail = error => ({
  type: GET_USERS_FAIL,
  payload: error,
})

export const getUserDetail = UserId => ({
  type: GET_USER_DETAIL,
  UserId,
})

export const getUserDetailSuccess = UserDetails => ({
  type: GET_USER_DETAIL_SUCCESS,
  payload: UserDetails,
})

export const getUserDetailFail = error => ({
  type: GET_USER_DETAIL_FAIL,
  payload: error,
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})
export const clearStripeError = () => ({
  type: CLEAR_STRIPE_ERROR,
})
export const deleteUser = user => ({
  type: DELETE_USER,
  payload: user,
})

export const deleteUserSuccess = user => ({
  type: DELETE_USER_SUCCESS,
  payload: user,
})

export const deleteUserFail = error => ({
  type: DELETE_USER_FAIL,
  payload: error,
})
export const resetData = () => ({
  type: RESET_DATA,
})

export const updateUserSeasonChange = guest => ({
  type: UPDATE_SEASON_CHANGE_STATUS,
  payload: guest,
})

export const updateUserSeasonChangeSuccess = guest => ({
  type: UPDATE_SEASON_CHANGE_STATUS_SUCCESS,
  payload: guest,
})

export const updateUserSeasonChangeFail = error => ({
  type: UPDATE_SEASON_CHANGE_STATUS_FAIL,
  payload: error,
})

export const blacklistUser = user => ({
  type: BLACKLIST_USER,
  payload: user,
})

export const blacklistUserSuccess = user => ({
  type: BLACKLIST_USER_SUCCESS,
  payload: user,
})

export const blacklistUserFail = error => ({
  type: BLACKLIST_USER_FAIL,
  payload: error,
})

export const getUnApprovalCounts = () => ({
  type: GET_UNAPPROVE_COUNT,
})

export const getUnApprovalCountSuccess = data => ({
  type: GET_UNAPPROVE_COUNT_SUCCESS,
  payload: data,
})

export const getUnApprovalCountFail = error => ({
  type: GET_UNAPPROVE_COUNT_FAIL,
  payload: error,
})

export const getExportUser = payload => ({
  type: GET_EXPORT_USERS,
  payload,
})

export const getExportUserSuccess = SessionTicket => ({
  type: GET_EXPORT_USERS_SUCCESS,
  payload: SessionTicket,
})

export const getExportUserFail = error => ({
  type: GET_EXPORTED_USERS_FAIL,
  payload: error,
})

export const resetExportFileData = () => ({
  type: RESET_EXPORT_DATA,
})

export const chargeUser = user => ({
  type: CHARGE_USER,
  payload: user,
})

export const chargeUserSuccess = bills => ({
  type: CHARGE_USER_SUCCESS,
  payload: bills,
})

export const chargeUserFail = error => ({
  type: CHARGE_USER_FAIL,
  payload: error,
})

export const priceBill = user => ({
  type: GET_BILL_PRICE,
  payload: user,
})

export const priceBillSuccess = bills => ({
  type: GET_BILL_PRICE_SUCCESS,
  payload: bills,
})

export const priceBillFail = error => ({
  type: GET_BILL_PRICE_FAIL,
  payload: error,
})

export const getChangeSeasonUsers = payload => ({
  type: GET_CHANGESEASON_USERS,
  payload: { ...payload },
})

export const getChangeSeasonUsersSuccess = Users => ({
  type: GET_CHANGESEASON_USERS_SUCCESS,
  payload: Users,
})


export const getChangeSeasonUsersFail = error => ({
  type: GET_CHANGESEASON_USERS_FAIL,
  payload: error,
})
